import React from "react";
import { toast } from "sonner";
import { Facebook, Twitter, Instagram, Home, Download, Copy } from "lucide-react";
import { resolveMedia, rescuePublicUrl, isUnverified } from "../lib/media";
import { BACKEND_URL } from "../lib/api";

function caption(r, url) {
  const tag = isUnverified(r) ? "Reported incident — current rescue status unconfirmed. " : "";
  return (
    `🚨 URGENT RESCUE: ${r.title}\n${tag}${r.animals_description} · ${r.city}, ${r.state_code || r.state}\n` +
    `Paws on Record is calling on RESCUE ORGANIZATIONS to contact us to help. Fosters, transport volunteers & individuals can offer help too.\n\nContact us / offer help: ${url}\n\n` +
    `#PawsOnRecord #UrgentRescue #AdoptDontShop #FosterSavesLives #${(r.city || "").replace(/\s+/g, "")}`
  );
}

const btn = "inline-flex items-center gap-1.5 px-3 py-2 text-[11px] font-bold uppercase tracking-widest border border-zinc-900 text-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors";
const open = (u) => window.open(u, "_blank", "noopener,noreferrer,width=640,height=640");

export default function RescueShareButtons({ rescue }) {
  const url = rescuePublicUrl(rescue.id);
  // Crawler-friendly link (OG preview with flyer), redirects people to the page.
  const shareUrl = `${(BACKEND_URL || "").replace(/\/+$/, "")}/api/urgent-rescues/${rescue.id}/share`;
  const text = caption(rescue, url);
  const copy = async (msg) => {
    try { await navigator.clipboard.writeText(text); toast.success(msg); }
    catch { toast.error("Couldn't copy — select the text manually."); }
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid="rescue-share-buttons">
      <button type="button" className={btn} onClick={() => copy("Caption copied — paste it into Instagram.")} data-testid="share-copy-instagram">
        <Instagram size={13} /> Copy for Instagram
      </button>
      <button type="button" className={btn} onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`)} data-testid="share-facebook">
        <Facebook size={13} /> Facebook
      </button>
      <button type="button" className={btn} onClick={() => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(`🚨 URGENT RESCUE: ${rescue.title} — Paws on Record is calling for help`)}&url=${encodeURIComponent(shareUrl)}`)} data-testid="share-x">
        <Twitter size={13} /> X
      </button>
      <button type="button" className={btn} onClick={() => open(`https://nextdoor.com/sharekit/?source=pawsonrecord&body=${encodeURIComponent(text)}`)} data-testid="share-nextdoor">
        <Home size={13} /> Nextdoor
      </button>
      <button type="button" className={btn} onClick={() => copy("Caption + link copied.")} data-testid="share-copy-link">
        <Copy size={13} /> Copy text
      </button>
      {rescue.share_image_url && (
        <a href={resolveMedia(rescue.share_image_url)} download={`${rescue.id}.png`} target="_blank" rel="noreferrer" className={btn} data-testid="share-download-image">
          <Download size={13} /> Share image
        </a>
      )}
    </div>
  );
}
